import { render, staticRenderFns } from "./GameBuilderMusicQuestionStep.vue?vue&type=template&id=3ca9dcc4&scoped=true&"
import script from "./GameBuilderMusicQuestionStep.vue?vue&type=script&lang=js&"
export * from "./GameBuilderMusicQuestionStep.vue?vue&type=script&lang=js&"
import style0 from "./GameBuilderMusicQuestionStep.vue?vue&type=style&index=0&id=3ca9dcc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca9dcc4",
  null
  
)

export default component.exports